import _ from "lodash";
import { history } from "main";
import { Drawer } from "material-ui";
import React from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";

import { login } from "../../routes/Login/modules/login";
import classes from "./CoreLayout.scss";
import Menus from "./Menus";
import SideBarList from "./SideBarList";
import config from "config";

const MenuConfig = [
  {
    title: "Products",
    menus: [
      {
        title: "Overall summary",
        route: "/overall-summary",
      },
      {
        title: "Store Sales",
        route: "/detailed-analytics",
      },
      {
        title: "Product Sales",
        route: "/product-wise-sales-analytics",
      },
      {
        title: "Frequency Analysis",
        route: "/product-analytics/frequency-analysis",
      },
      {
        title: "Basket Analysis",
        route: "/basket-analysis",
      },
      {
        title: "Sales Forecast",
        route: "/product-sales-forecast",
      },
    ],
  },
  {
    title: "Customer Analysis",
    menus: [
      {
        title: "Lifecycle Management",
        route: "/purchases-clustering-analytics",
      },
      {
        title: "Feedback Analysis",
        route: "/form-response-analytics",
      },
      {
        title: "Frequency Analysis",
        route: "/customer-purchase",
      },
    ],
  },
  {
    title: "Store Operations",
    menus: [
      {
        title: "Merchandize Sales",
        route: "/category-analytics",
      },
      {
        title: "Store Sales Comparison",
        route: "/detailed-analytics",
      },
    ],
  },
  {
    title: "Campaign Analysis",
    menus: [
      {
        title: "Campaign Sales",
        route: "/sales-analytics",
      },
      {
        title: "Campaign Details",
        route: "/campaign-details-v2",
      },
    ],
  },
];

const handleSettingIcon = (e) => {
  history.push("/general-setting");
};

export class CoreLayout extends React.Component {
  constructor(props, prevProps) {
    super(props);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    const urlParams = new URLSearchParams(window.location.search);
    const navFrom = urlParams.get("navFrom");
    this.showSideBar = !!!(navFrom === "v2");
  }

  static defaultProps = {
    appName: "CASA",
  };

  state = {
    open: false,
  };

  toggleDrawer() {
    this.setState({ open: !this.state.open });
  }

  getRoutePath() {
    return _.get(this.getMenuItemDetails(), "showTopMenu")
      ? ""
      : _.get(this.props, "location.pathname");
  }

  menuRedirect(route, menuState) {
    this.setState({ currentMenuItemRoute: route });
    this.setState(menuState);
    history.push(route);
  }

  renderDrawer() {
    return (
      <Drawer
        open={this.state.open}
        docked={false}
        onRequestChange={this.toggleDrawer}
      >
        <SideBarList
          currentUser={_.get(this.props, "loginState.user")}
          onClick={this.toggleDrawer}
        />
      </Drawer>
    );
  }

  getMenuItemDetails() {
    // Need to refactor
    let path = _.get(this.props, "location.pathname");
    let topMenuItem = _.find(
      _.flatMap(MenuConfig, (menu) => menu.menus),
      { route: path }
    );
    let isFromTopMenuItem = false;
    let selectedSubMenu = MenuConfig[0].menus[0];
    if (topMenuItem) {
      isFromTopMenuItem = true;
      selectedSubMenu = topMenuItem;
    }
    let selectedMainMenuName = _.without(
      _.map(MenuConfig, (t) => {
        return !_.isEmpty(_.find(t.menus, { route: path })) ? t.title : "";
      }),
      ""
    );
    let selectedMainMenu = _.find(MenuConfig, {
      title: selectedMainMenuName[0],
    });
    let mainMenu = _.isEmpty(selectedMainMenu)
      ? _.head(MenuConfig)
      : selectedMainMenu;
    return {
      showTopMenu: isFromTopMenuItem,
      selectedMenu: mainMenu,
      selectedSubMenu: selectedSubMenu,
    };
  }

  render() {
    const shouldShowDrawer = this.props.location.pathname !== "/login";
    const drawerComponent = shouldShowDrawer && this.renderDrawer();
    let currentRoute = _.last(this.props.routes);
    if (_.get(currentRoute, "isPrintView")) {
      return <div className={classes.container}>{this.props.children}</div>;
    } else {
      let loginState = this.props.loginState || { isLoggedIn: false };
      if (!loginState.isLoggedIn && Boolean(this.props.route.keycloak.token)) {
        this.props.login({});
      }

      const buusinessUnitNameMap = (
        loginState.user ? loginState.user.tenant.brands : []
      ).reduce((acc, val) => {
        val.businesses.forEach((business) => {
          acc[business.id.toString()] = business.name;
        });
        return acc;
      }, {});

      const currentBu = new URLSearchParams(window.location.search).get("bu");

      if (!currentBu || !buusinessUnitNameMap[currentBu])
        window.location.href = config.dashboardV2;

      let appBarRight = loginState.isLoggedIn ? (
        <div className={classes.userAccountMenuCoreLayout}>
          <p className={classes.userTenantName}>
            {loginState.user.tenant.esKey}
          </p>
          <span className={classes.userTenantBusiness}>
            {buusinessUnitNameMap[
              new URLSearchParams(window.location.search).get("bu")
            ] || ""}
          </span>
        </div>
      ) : (
        <span />
      );
      let content = (
        <div style={{ backgroundColor: "#F8F8F8" }}>{this.props.children}</div>
      );
      let nameIcon = loginState.isLoggedIn
        ? _.capitalize(loginState.user.email.substr(0, 1))
        : "C";

      const baseSrc = new URL(config.dashboardV2);
      const params = new URLSearchParams(window.location.search);
      params.forEach(
        (value, key) => key === "bu" && baseSrc.searchParams.append(key, value)
      );
      baseSrc.searchParams.append("ref", "v1-nav-logo");
      const showNav = !params.has("ref", "lms");
      return (
        <div className={classes.container}>
          {showNav && (
            <div className={classes.headerContainer}>
              <a
                href={baseSrc.href}
                target="_blank"
                style={{ display: "flex" }}
              >
                <img
                  src="/icons/casa-icon.svg"
                  style={{ height: 25, width: 95, cursor: "pointer" }}
                ></img>
              </a>
              <div className={classes.userAccountContainer}>
                <div className={`${classes.nameIcon}`}>
                  <span className={classes.textStyle}>{nameIcon}</span>
                </div>
                {appBarRight}
              </div>
              {/* <RenderWhen
              requiredPermissions={["config_manage"]}
              currentUser={loginState.user}
              authorized={
                <SettingsIcon
                  className={classes.settingsIcon}
                  onClick={handleSettingIcon}
                ></SettingsIcon>
              }
            /> */}
            </div>
          )}
          {content}
          <ReactTooltip />
        </div>
      );
    }
  }
}

CoreLayout.propTypes = {
  children: React.PropTypes.element.isRequired,
};

const mapActionCreators = {
  login,
};

const mapStateToProps = (state) => ({
  loginState: state.loginState,
});

export default connect(mapStateToProps, mapActionCreators)(CoreLayout);



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js